if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: import"); // eslint-disable-line no-console
import "./app/ceres/publicPath";
import Vue from "vue";
import Vuex from "vuex";
import NotificationService from "./app/ceres/services/NotificationService";
import TranslationService from "./app/ceres/services/TranslationService";
import "bootstrap";
import { createApp, beforeCreate } from "./ssr-category";
import "custom-event-polyfill";
import { initClientListeners, initClientStore, createStore } from "./app/eros/store/category";
import { initListener } from "./app/ceres/services/ApiService";
import { mount } from "./mount";
import "./app/eros/plugins/jQuery";
if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: import"); // eslint-disable-line no-console

if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: mount"); // eslint-disable-line no-console
Vue.prototype.$mount = mount;
if (App.Eros.Config.general.benchmarkJS) {
	console.timeEnd("entry-client-category: mount"); // eslint-disable-line no-console
	Vue.config.performance = true;
}

// defines if the render location is the client
App.isSSR = false;
App.isSSREnabled = App.config.log.performanceSsr;

beforeCreate();

window.createApp = (selector) => {
	if (App.Eros.Config.general.benchmarkJS) console.time("createApp"); // eslint-disable-line no-console
    // client-specific bootstrapping logic...
    const app = createApp({
        template: "#ssr-script-container"
    }, store);

	if (window.__INITIAL_STATE__) {
		if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: replaceState"); // eslint-disable-line no-console
		store.replaceState(window.__INITIAL_STATE__);
		if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: replaceState"); // eslint-disable-line no-console
	}

    app.$mount(selector, true);
    window.vueApp = app;

    initListener();
    initClientListeners(store);
    initClientStore(store);
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("createApp"); // eslint-disable-line no-console
};

if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: createStore"); // eslint-disable-line no-console
const store = createStore();

if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: createStore"); // eslint-disable-line no-console

if (window.__INITIAL_STATE__) {
	if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: replaceState"); // eslint-disable-line no-console
    store.replaceState(window.__INITIAL_STATE__);
	if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: replaceState"); // eslint-disable-line no-console
}

if (App.Eros.Config.general.benchmarkJS) console.time("register window variables"); // eslint-disable-line no-console
window.Vue = Vue;
window.Vuex = Vuex;
window.NotificationService = NotificationService;
window.ceresTranslate = TranslationService.translate;
window.vueEventHub = new Vue();
window.ceresStore = store;
if (App.Eros.Config.general.benchmarkJS) console.timeEnd("register window variables"); // eslint-disable-line no-console

// =========================
// Common
// =========================
if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: import common"); // eslint-disable-line no-console
// import "./app/eros/common/carouselMobileCheck";
import "./app/eros/common/registerMutationObserver";
if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: import common"); // eslint-disable-line no-console

// =========================
// External Plugins
// =========================
// if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: import external plugins"); // eslint-disable-line no-console
// import "./app/eros/plugins/external/svbadge";
// if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: import external plugins"); // eslint-disable-line no-console

// =========================
// Landing
// =========================
// import "./app/eros/common/landing/sideNavi";
// import "./app/eros/common/landing/smoothScroll";

if (App.Eros.Config.general.benchmarkJS) console.time("entry-client-category: import main"); // eslint-disable-line no-console
import "./app/eros/main";
if (App.Eros.Config.general.benchmarkJS) console.timeEnd("entry-client-category: import main"); // eslint-disable-line no-console
